// extracted by mini-css-extract-plugin
export default {"text":"legalDocumentBody_text__q-Cv0"};